import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";

interface ltdSalesDataInterface {
  Gross_Units:number;
  Gross_Dollars:number;
  Returns_Units:number;
  Returns_Dollars:number;
  Net_Units:number;
  Net_Dollars:number;
  Sell_Through_LTD:number;
}

interface TitleListLTDState {
  data: ltdSalesDataInterface;
  status: string;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
}
const initialState: TitleListLTDState = {
  data: {
    Gross_Units:0,
    Gross_Dollars:0,
    Returns_Units:0,
    Returns_Dollars:0,
    Net_Units:0,
    Net_Dollars:0,
    Sell_Through_LTD:0,
  },
  status: "",
  error: null,
  statusCode: 0,
  isLoading: false,
};

export const FetchTitleListLTDSalesRecord = createAsyncThunk(
  "FetchTitleListLTDSalesRecord",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.LTDTITLESALESDATA,data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

const TitleListLTDSlice = createSlice({
  name: "TitleListLTDData",
  initialState,
  reducers: {
    clearLTDData: (state) => {
      state.data = initialState.data;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(FetchTitleListLTDSalesRecord.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(FetchTitleListLTDSalesRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.data = action.payload.data.totals;
      })
      .addCase(FetchTitleListLTDSalesRecord.rejected, (state) => {
        state.isLoading = false;
        state.status = "Failed";
        state.error = "Error";
      });
  },
});

export const {clearLTDData
} = TitleListLTDSlice.actions;
export default TitleListLTDSlice.reducer;
